<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['confirm']);

const { t } = useI18n();

const isDeleting = ref(false);
const dialogRef = ref(null);

const handleDialogConfirm = async () => {
  isDeleting.value = true;
  try {
    emit('confirm');
  } finally {
    isDeleting.value = false;
  }
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('CONTACTS_LAYOUT.HEADER.ACTIONS.DELETE_ALL_CONTACTS.TITLE')"
    :description="
      t('CONTACTS_LAYOUT.HEADER.ACTIONS.DELETE_ALL_CONTACTS.DESCRIPTION')
    "
    :confirm-button-label="
      t('CONTACTS_LAYOUT.HEADER.ACTIONS.DELETE_ALL_CONTACTS.CONFIRM')
    "
    :is-loading="isDeleting"
    :disable-confirm-button="isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
